import { render, staticRenderFns } from "./ModalAddTime.vue?vue&type=template&id=04aa487e&"
import script from "./ModalAddTime.vue?vue&type=script&lang=js&"
export * from "./ModalAddTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports